import { ModalWizard } from '@monorepo/shared/componentsV2/modalWizard/modalWizard';
import { USAGE_TRACKING_PREFIX } from '@monorepo/shared/constants/usageTracking';
import React, { useCallback, useMemo } from 'react';
import { CreateFormTemplateFieldRequestValues } from '../types';
import { EditNewFieldWizardPage } from './EditNewFieldWizardPage';
import { SelectFieldTypeWizardPage } from './SelectFieldTypeWizardPage';

export type AddFieldModalProps = {
  isInDuplicableSection: boolean;
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (field: CreateFormTemplateFieldRequestValues) => void;
};

export function AddFieldModal({
  isInDuplicableSection,
  isOpen,
  onClose,
  onSubmit,
}: AddFieldModalProps) {
  const handleSubmit = useCallback(
    async (fieldFormValues: CreateFormTemplateFieldRequestValues) => {
      onSubmit(fieldFormValues);
    },
    [onSubmit],
  );

  const wizardPages = useMemo(
    () => [
      <SelectFieldTypeWizardPage />,
      <EditNewFieldWizardPage isInDuplicableSection={isInDuplicableSection} />,
    ],
    [isInDuplicableSection],
  );

  if (!isOpen) {
    return null;
  }

  return (
    <ModalWizard<CreateFormTemplateFieldRequestValues>
      isEditing={false}
      itemLabel="field"
      modalId={`${USAGE_TRACKING_PREFIX}-add-form-template-field-modal`}
      onClose={onClose}
      onPageSubmit={handleSubmit}
      title="Add field"
      wizardPages={wizardPages}
      completionButtonText="Apply"
      showBackButton
    />
  );
}
